import { useBooking } from "@/context/BookingContext";
import PullQuote from "@/components/PullQuote";
import { CAMP_TYPES, QUOTES } from "@/data/site";
import { useSettings } from "@/context/SettingsContext";
import Seo from "@/components/Seo";
import { PAGE_META } from "@/lib/seo";
import { Phone } from "lucide-react";

export default function SummerCamps() {
  const { openBooking } = useBooking();
  const { settings } = useSettings();
  const contact = settings.contact;
  return (
    <div data-testid="summer-camps-page">
      <Seo {...PAGE_META["summer-camps"]} />
      {/* Full-bleed hero */}
      <section className="relative h-[70vh] min-h-[460px] overflow-hidden">
        <img
          src="/assets/hero-photos/gaming-lounge-summer-camps-992.webp"
          srcSet="/assets/hero-photos/gaming-lounge-summer-camps-600.webp 600w, /assets/hero-photos/gaming-lounge-summer-camps-992.webp 992w"
          sizes="100vw"
          width="992"
          height="744"
          alt="Child playing Fortnite in a moody blue-lit RGV Gaming summer camp lounge"
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-[#0A0A0A]/30" />
        <div className="relative z-10 h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end pb-16">
          <p className="text-rgv-red font-display uppercase tracking-[0.3em] mb-3">Ages 7–17 · June–August</p>
          <h1 className="font-display font-extrabold italic uppercase fluid-h1">
            Summer <span className="text-rgv-red">Camps</span>
          </h1>
          <h2 className="mt-3 font-display uppercase italic text-xl sm:text-2xl text-white/90">
            Esports & Gaming Summer Camps
          </h2>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
        <p className="text-rgv-gray text-lg leading-relaxed">
          RGV Gaming&rsquo;s summer camps build camaraderie, sharpen skills, and connect kids over a
          shared love of gaming. Running June through August for ages 7–17. Every camp is safe,
          educational, and — most importantly — fun.
        </p>

        <h3 className="font-display uppercase italic text-3xl mt-12 mb-6">
          Camp <span className="text-rgv-red">Types</span>
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {CAMP_TYPES.map((c, i) => (
            <div
              key={c}
              data-testid={`camp-type-${i}`}
              className="hover-glow border border-rgv-maroon rounded-xl bg-[#111] p-6 text-center font-display uppercase text-lg"
            >
              {c}
            </div>
          ))}
        </div>

        <div className="mt-14 text-center border border-rgv-darkred rounded-2xl bg-gradient-to-br from-[#280000] to-[#0A0A0A] p-10">
          <h3 className="font-display uppercase italic text-3xl mb-4">Contact Us Today To Sign Up!</h3>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href={`tel:${contact.phone}`} data-testid="camps-call-btn" className="btn-skew btn-red px-8 py-4 text-lg">
              <span className="flex items-center gap-2"><Phone className="h-5 w-5" /> {contact.phone}</span>
            </a>
            <button onClick={() => openBooking("Summer Camp")} data-testid="camps-inquire-btn" className="btn-skew btn-outline-red px-8 py-4 text-lg">
              <span>Send An Inquiry</span>
            </button>
          </div>
        </div>

        <PullQuote quotes={QUOTES.camps} />
      </section>
    </div>
  );
}
